// Lightweight blog post registry. Each post's body is a small JSX component.
import HowToKeepTrackOfDocumentExpiryDates from "../content/blog/how-to-keep-track-of-document-expiry-dates";
import ConstructionComplianceChecklistIndia from "../content/blog/construction-compliance-checklist-india";

export const POSTS = [
  {
    slug: "construction-compliance-checklist-india",
    title: "Construction Compliance Checklist in India: Documents, Licences & Renewal Dates",
    description:
      "A practical compliance checklist for Indian construction companies and contractors — contractor licences, labour and safety documents, insurance, equipment certificates and renewal-date tracking.",
    excerpt:
      "From contractor licences and BOCW registrations to CAR/EAR insurance, PUC and load-test certificates — a practical checklist to keep every renewal date under control on Indian construction sites.",
    tag: "Guide",
    datePublished: "2026-09-23",
    dateModified: "2026-09-23",
    readTime: "8 min read",
    body: ConstructionComplianceChecklistIndia,
  },
  {
    slug: "how-to-keep-track-of-document-expiry-dates",
    title: "How to Keep Track of Document Expiry Dates: A Simple Guide",
    description:
      "A simple, practical guide to keeping track of document expiry and renewal dates — for individuals, professionals and small businesses.",
    excerpt:
      "Forgetting a renewal or expiry date can be costly and stressful. Here's a simple approach — from a manual checklist to a dedicated renewal tracking app — that anyone can follow.",
    tag: "Guide",
    datePublished: "2026-09-16",
    dateModified: "2026-09-16",
    readTime: "6 min read",
    body: HowToKeepTrackOfDocumentExpiryDates,
  },
];

export const getPost = (slug) => POSTS.find((p) => p.slug === slug);
